import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { getJSON } from "@/lib/api";

export function ThreatLevelChip() {
  const [t, setT] = useState(null);
  useEffect(() => { getJSON("/threat-level").then(setT).catch(() => {}); }, []);
  if (!t?.level) return null;
  return (
    <Link to="/guides/terrorist-weapons-attack" data-testid="threat-level-chip" title={t.meaning} className="ml-2 inline-flex items-center gap-1 rounded bg-slate-700 px-2 py-0.5 font-semibold text-white hover:bg-slate-600">
      <ShieldAlert className="h-3 w-3" /> UK threat level: {t.level}
    </Link>
  );
}
